export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Black-fb67c7b5edcc3a8bc4c41094979eb4a7.woff2";